import React from 'react';
import { PortalContext } from '../../../../../context/portal-context';
import { formatOwnership } from '../../../../../tracking/tracking-helper';
import { useTrackingManager } from '../../../../../tracking/use-tracking-manager';

export const useBonoPosventaTracker = () => {
	const sectionName = 'Bono Taller';
	const trackingManager = useTrackingManager();
	// User vehicles
	const { portalService } = React.useContext(PortalContext);
	const userVehicles = portalService.getPersonVehicles().getValue();

	const trackOpenLayerClick = () => {
		const contentIdValue = `Aprovéchalos - ${sectionName} - Open Layer`;
		trackingManager.trackClubVWButtonClick(
			contentIdValue,
			{ contentId: contentIdValue },
			{ vehicle: formatOwnership(userVehicles?.vehicles) },
		);
	};

	const trackLayerLoad = React.useCallback(() => {
		trackingManager.trackClubVWLayerLoad(
			{ contentId: `${sectionName}` },
			{ vehicle: formatOwnership(userVehicles?.vehicles) },
		);
	}, [trackingManager, userVehicles]);

	const trackLayerCloseClick = () => {
		const contentIdValue = `${sectionName}`;
		trackingManager.trackClubVWLayerCloseClick(contentIdValue, { contentId: contentIdValue });
	};

	const trackDownloadBonoTaller = () => {
		const contentIdValue = `Descarga tu bono taller - ${sectionName}`;
		trackingManager.trackClubVWDownloadClick(
			contentIdValue,
			{ contentId: contentIdValue },
			{ vehicle: formatOwnership(userVehicles?.vehicles) },
		);
	};

	const trackCitaServicioOficialClick = () => {
		const contentIdValue = `Pide cita en tu Servicio Oficial - ${sectionName}`;
		trackingManager.trackClubVWButtonClick(
			contentIdValue,
			{ contentId: contentIdValue },
			{ vehicle: formatOwnership(userVehicles?.vehicles) },
		);
	};

	return {
		trackOpenLayerClick,
		trackLayerLoad,
		trackLayerCloseClick,
		trackDownloadBonoTaller,
		trackCitaServicioOficialClick,
	};
};
